export enum AppCookies {
  NEXT_LOCALE = 'NEXT_LOCALE',
  ADMIN_AUTH_INFO = 'adminAuthInfo',
  ADMIN_AUTH_CLIENT = 'adminAuthClient',
  ADMIN_AUTH_STATE = 'adminAuthState',
  USER_AUTH_STATE = 'userAuthState',
  SESSION_REPORT_AUTH_STATE = 'sessionReportAuthState',
}